import settings from './settings.json';

/**
 * Typed accessors for stored-balance numeric config values in settings.json.
 *
 *   balancePurchaseBonusPercent   1        — bonus % credited to non-withdrawable bucket on purchase
 *   balanceMinPurchaseCents       100000   — minimum single purchase ($1,000.00)
 *   balanceMaxCents               2000000  — per-family balance ceiling ($20,000.00)
 *   enableCardAddFunds            false    — show the Card option on the BHCS Cash Add Funds screen
 */
export function getBalancePurchaseBonusPercent(): number {
  return settings.balancePurchaseBonusPercent;
}

export function getBalanceMinPurchaseCents(): number {
  return settings.balanceMinPurchaseCents;
}

export function getBalanceMaxCents(): number {
  return settings.balanceMaxCents;
}

/**
 * Whether the Card payment option is shown on the BHCS Cash Add Funds screen.
 * When false, parents can only add funds by ACH or Zelle (both fee-free).
 * Card invoice checkout / split-pay are unaffected by this flag.
 */
export function getEnableCardAddFunds(): boolean {
  return settings.enableCardAddFunds;
}
